import { MdOutlineStackedBarChart } from "react-icons/md";

const getDataFieldsBar = () => {
  return [
    {
      title: "X-Axis",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "rows",
      itemInArray: true,
    },
    {
      title: "Y-Axis",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "tooltip",
      itemInArray: true,
    },
  ];
};

const getCustomizationFieldBar = () => {
  return [
    {
      title: "Color",
      type: "COLOR",
      reduxKey: "colorSchemeid",
      defaultType: "RANDOM",
    },
    {
      title: "Bar Size",
      type: "range",
      defaultValue: "30",
      minValue: 0,
      maxValue: 100,
      reduxKey: "barsize",
      itemInArray: false,
    },
    //label
    {
      title: "Label",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isLabelVisible",
      innerComponents: [
        {
          title: "Position",
          type: "SELECT_BOX",
          reduxKey: "labelPosition",
          options: [
            { label: "Top", value: "top" },
            { label: "Left", value: "left" },
            { label: "Right", value: "right" },
            { label: "InsideBottom", value: "insideBottom" },
            // { label: "Bottom", value: "bottom" },
            { label: "Center", value: "center" },
            // { label: "InsideTopLeft", value: "insideTopLeft" },
            // { label: "InsideTop", value: "insideTop" },
            // { label: "InsideLeft", value: "insideLeft" },
            // { label: "InsideRight", value: "insideRight" },
            // { label: "InsideBottomLeft", value: "insideBottomLeft" },

            // { label: "InsideBottomRight", value: "insideBottomRight" },
          ],
          defaultValue: { label: "Top", value: "top" },
        },

        {
          title: "Font Color",
          type: "text",
          defaultValue: "07090c",
          minValue: 0,
          maxValue: 40,
          reduxKey: "labelFontColor",
        },
        {
          title: "Font Size",
          type: "range",
          defaultValue: 11,
          minValue: 9,
          maxValue: 90,
          reduxKey: "barlabelFontSize",
        },

        {
          title: "Rotate",
          type: "range",
          defaultValue: 0,
          minValue: 0,
          maxValue: 360,
          reduxKey: "labelRotate",
        },
      ],
    },

    {
      title: "Refrence Line",
      type: "text",
      defaultValue: 0,
      reduxKey: "referenceLine",
    },
    {
      title: "Grid",
      type: "checkbox",
      defaultValue: true,
      reduxKey: "isGridVisible",
    },
    {
      title: "TransPose",
      type: "checkbox",
      defaultValue: false,
      reduxKey: "isTransposeVisible",
    },

    {
      title: "Axes label",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isAxeslabelVisible",
      innerComponents: [
        {
          title: "Font Size",
          type: "range",
          defaultValue: 25,
          minValue: 19,
          maxValue: 40,
          reduxKey: "axeslabelFontSize",
        },
        {
          title: "Font Color",
          type: "text",
          defaultValue: "#070807",
          minValue: 0,
          maxValue: 40,
          reduxKey: "labelFontColor",
        },
      ],
    },

    //legend
  ];
};
const getBarChartDetails = () => {
  return {
    chartType: "recharts",
    imageSrc: "/graph_img/Stackbarchart.png",
    label: "Bar",
    value: "stackedbarchart",
    icon: <MdOutlineStackedBarChart className="text-xl text-blue-950" />,
    fileName: "BarChartComp.js",
  };
};
export { getDataFieldsBar, getCustomizationFieldBar, getBarChartDetails };
